export default __webpack_public_path__ + "static/media/hht1_ep08_timeline_q01_b.f09b56c1.png";